import React, {Fragment, FunctionComponent} from "react";
import {PremiumService} from "@App/types";
import {Checkbox} from "@App/Components/common/Checkbox";
import {PremiumServiceIsReplacementOrPickup} from "@App/utils/conditionals/premiumServices";
import {OrganizationIsArvalOrMobilityConcept} from "@App/utils/conditionals/combinations";
import {useTranslation} from "react-i18next";

type SubServiceStepProps = {
    availableSubservices: PremiumService[],
    premiumServices: PremiumService[],
    toggled: any,
    togglePremiumServiceCarReplacementOrPickup: any,
    togglePremiumService: any,
    nextStep: any
    required?: boolean
};

export const SubServiceStep: FunctionComponent<SubServiceStepProps> = (props: SubServiceStepProps)  => {

    const {t} = useTranslation()

    return (
        <Fragment>
            <div className="overflow-hidden mb-4 mt-4">
                {props.availableSubservices?.map((premiumService) => (
                    <Fragment key={'fragment-' + premiumService.id}>
                        <Checkbox key={premiumService.id} status={props.toggled(premiumService, props.premiumServices)}
                                  title={premiumService.name + (premiumService.paid ? '*' : '')}
                                  onChange={() =>
                                      OrganizationIsArvalOrMobilityConcept(organization) && PremiumServiceIsReplacementOrPickup(premiumService) ?
                                          props.togglePremiumServiceCarReplacementOrPickup(premiumService, props.premiumServices) :
                                          props.togglePremiumService(premiumService, props.premiumServices)}
                        />
                    </Fragment>
                ))}
                <div
                    onClick={props.nextStep}
                    className={`${props.premiumServices.length >= 1 || props.required === false ? '' : 'cursor-pointer pointer-events-none no-underline'}`}>
                    <div
                        className={`${props.premiumServices.length >= 1 || props.required === false ? 'bg-primary' : 'bg-primary-100'} w-full md:w-80 px-8 py-2 mt-4 text-white rounded text-center font-serif font-bold cursor-pointer no-underline`}>
                        {t('weiter')}
                    </div>
                </div>
            </div>
        </Fragment>
    )
}
